
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.555 14.923s-1.028-.411-1.85-.77c0 .256-.154.461-.154.461l-.051.052s-.051 0-.051-.052c0 0-.103-.205-.154-.462-.822.36-1.85.77-1.85.77h-.051s-.051 0-.051-.05l-.052-.309c0-.103 0-.514.154-.565.103-.051 1.593-.976 1.85-1.13l-.617-2.825s-.103-.36-.41-.411c-.104 0-.206-.052-.258-.052H5.96l-.051.617c0 .051-.052.051-.052.051h-.103l-.205.976c0 .052-.051.052-.051.052-.052 0-.052 0-.052-.052l-.257-.924-.154-.052c-.051-.051-.154-.565-.102-.924C4.162 9.22.668 8.81.668 8.81s-.257-.051-.257-.411.103-.411.36-.462c.205 0 3.698-.052 4.263-.052 0-.308 0-.924.103-1.078l.051-.052H5.6c.052 0 .257.154.309 1.079h.565c0-.565-.103-4.47.36-6.062l-.977-.102s-.051 0-.051-.052c0 0-.103-.154-.103-.41 0-.206.103-.257.206-.257L6.986.899c.154-.36.36-.822.514-.822h.051c.154 0 .36.411.463.822l1.13.103c.103 0 .205.051.205.257 0 .257-.102.41-.102.41s-.052 0-.052.052l-.976.103v.051c.411 1.593.36 5.445.36 6.01h.565c.051-.924.205-1.027.257-1.078h.41s.052 0 .052.05c.103.104.103.771.103 1.08.513 0 4.058.051 4.263.051.257 0 .36.103.36.462s-.206.411-.206.411-3.493.411-4.263.514c.051.308-.103.822-.103.873l-.205.154-.206.874c0 .05-.051.05-.051.05-.052 0-.052 0-.052-.05l-.205-.976h-.103c-.051 0-.051 0-.051-.052L9.04 9.58c-.051 0-.154.052-.308.052-.36.051-.411.41-.411.41l-.617 2.826c.257.154 1.747 1.079 1.85 1.13.154.051.154.462.154.565l-.103.308-.051.052z"}})])
          )
        }
      }
    